import React, { useEffect, useState } from 'react';
import css from './HeroSearchCover.module.css';
import BrandIconCard from '../../../../../components/BrandIconCard/BrandIconCard';
import {
  FieldDateRangePicker,
  FieldLocationAutocompleteInput,
  IconClose,
  OutsideClickHandler,
} from '../../../../../components';
import { Form as FinalForm } from 'react-final-form';
import Field from '../../../Field';
import { FormattedMessage, useIntl } from 'react-intl';
import GuestAndDogField from '../../../../../components/GuestAField/GuestField';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
 
import { saveRecentLocationToUser } from '../../../../ProfileSettingsPage/ProfileSettingsPage.duck';
import { getRecentLocations, saveRecentLocation } from '../../../../../util/recentLocations';

const SearchFilter = props => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user.currentUser);
  const isLoggedIn = !!currentUser?.id;
  const[showPredictions, setShowPredictions] = useState(false);
  const [recentLocations, setRecentLocations] = useState(false);
  const [showWhoModal, setShowWhoModal] = useState(false);
  const [adults, setAdults] = useState(0);
  const [kids, setKids] = useState(0);
  const [infants, setinfants] = useState(0); 
  const identity = v => v; 
  useEffect(() => {
    if (isLoggedIn) {
      const recents = currentUser?.attributes?.profile?.publicData?.recentLocations || [];
      setRecentLocations(recents);
    } else {
      setRecentLocations(getRecentLocations());
    }
  }, [isLoggedIn, currentUser]);

  const handleLocationChange = (location, form) => { 
    if (!location) return; 
    const label = location?.address;
    if (!label) return;
  
    const entry = { label, location }; 
    saveRecentLocation(location);  
    if (isLoggedIn) {
      setRecentLocations(prev => {
        const filtered = prev.filter(e => e.label !== label);
        return [entry, ...filtered].slice(0,1);
      });
      dispatch(saveRecentLocationToUser(location));
    }
  
    setRecentLocations(prev => {
      const filtered = prev.filter(e => e.label !== label);
      return [entry, ...filtered].slice(0,1);
    });
  };
  
  return (
    <FinalForm
      {...props}
      keepDirtyOnReinitialize={true}
      render={({ handleSubmit, values, form }) => {
        const isAnyGuestOrDogSelected = adults > 0 || kids > 0 || infants > 0;

        const handleIncrement = (setFunc, fieldName, value) => {
          const newValue = value + 1;
          setFunc(newValue);
          form.change(fieldName, newValue);
        };

        const handleDecrement = (setFunc, fieldName, value) => {
          if (value > 0) {
            const newValue = value - 1;
            setFunc(newValue);
            form.change(fieldName, newValue);
          }
        };

        const clearGuestAndDogField = () => {
          setAdults(0);
          setKids(0);
          setinfants(0);
          form.change('adults', 0);
          form.change('kids', 0);
          form.change('infants', 0);
        };
        

        return (
          <form className={css.formContainer} onSubmit={handleSubmit}>
            <div
              className={classNames(css.searchCover, {
                [css.searchCoverMobile]: props.searchMobile,
              })}
            >
              <div className={css.searchBorder}>
                <div
                  className={classNames(css.searchFilterBox, {
                    [css.searchMobileFilterBox]: props.searchMobile,
                  })}
                >
                  <div
                    className={classNames(css.searchBox, {
                      [css.searchPageBox]: props.searchFilter,
                      [css.searchMobileBox]: props.searchMobile,
                    })}
                  >
                    {props.closeBtn === true && (
                      <button
                        type="button"
                        onClick={e => {
                          e.preventDefault();
                          props.closeBtnFnx(e);
                        }}
                        className={css.closeBtn}
                      >
                        <IconClose />
                      </button>
                    )}

                    <div className={css.searchListingInput}>  
                    <OutsideClickHandler onOutsideClick={() => setShowPredictions(false)}>
                      <FieldLocationAutocompleteInput
                        className={css.locationInput}
                        name="location"
                        placeholder={intl.formatMessage({
                          id: 'HeroSearchCover.addressPlaceholder',
                        })}
                        useDefaultPredictions={true}
                        format={identity}
                        handleLocationChange={place => handleLocationChange(place, form)}
                        recentLocations={recentLocations}
                        setShowPredictions={setShowPredictions}
                        showPredictions={showPredictions}
                        isLandingPage={true}
                      />
                       </OutsideClickHandler>
                    </div>

                    <div className={css.dateRow}>
                      <div className={css.arrivalDates}>
                        <div className={css.searchItem}>
                          <div className={css.dateText}>
                            <FieldDateRangePicker
                              className={css.datePickerInput}
                              rootClassName={css.datePickerRoot}
                              id="dateRange"
                              name="dateRange"
                              placeholderText={intl.formatMessage({
                                id: 'HeroSearchCover.addDates',
                              })}
                              label=""
                              startDateId="startDateInput"
                              startDatePlaceholderText={intl.formatMessage({
                                id: 'HeroSearchCover.startDatePlaceholder',
                              })}
                              endDatePlaceholderText={intl.formatMessage({
                                id: 'HeroSearchCover.endDatePlaceholder',
                              })}
                              endDateId="endDateInput"
                              isDaily={true}
                              isDayBlocked={() => false}
                              isOutsideRange={null}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={css.lastBox}>
                      <div className={css.arrivalDatesBox}>
                        <div className={css.searchItemBox}>
                          <div className={css.guestBox}>
                            <div
                              onClick={() => setShowWhoModal(!showWhoModal)}
                              className={css.guestInput}
                            >
                              <div className={css.guestNumber}>
                                <span className={css.guestMobile}>
                                  <BrandIconCard type="guest" />
                                </span>
                                {adults + kids > 0 && (
                                  <span className={css.black}>
                                    <FormattedMessage id="HeroSearchCover.guests" />
                                    {adults + kids}
                                  </span>
                                )}
                                {infants > 0 && (
                                  <span className={css.black}>
                                    <FormattedMessage id="HeroSearchCover.Infants" />
                                    {infants}
                                  </span>
                                )}
                                {adults + kids === 0 && infants === 0 && (
                                  <span className={css.gray}>
                                    <FormattedMessage id="HeroSearchCover.selectGuest" />
                                  </span>
                                )}
                              </div>
                            </div>
                            {showWhoModal && (
                              <OutsideClickHandler
                                className={css.guestCount}
                                onOutsideClick={() => setShowWhoModal(false)}
                              >
                                <GuestAndDogField
                                  isAnyGuestOrDogSelected={!isAnyGuestOrDogSelected}
                                  setKids={val => setKids(val)}
                                  setAdults={val => setAdults(val)}
                                  setinfants={val => setinfants(val)}
                                  adults={adults}
                                  kids={kids}
                                  infants={infants}
                                  handleDecrement={(setFunc, fieldName, value) =>
                                    handleDecrement(setFunc, fieldName, value)
                                  }
                                  handleIncrement={(setFunc, fieldName, value) =>
                                    handleIncrement(setFunc, fieldName, value)
                                  }
                                  className={css.guestAndDogField}
                                  hideGuestAndDogField={() => setShowWhoModal(false)}
                                  clearGuestAndDogField={clearGuestAndDogField}
                                />
                              </OutsideClickHandler>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={css.btnContainer}>
                      <button
                        type="button"
                        onClick={e => {
                          e.preventDefault();
                          props.closeBtnFnx(e);
                        }}
                        className={css.closeBtnBottom}
                      >
                        Close
                      </button>
                      <div className={css.bookButton}>
                        <button type="submit">
                          <span className={css.bookText}>
                            {' '}
                            <FormattedMessage id="HeroSearchCover.search" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        );
      }}
    />
  );
};


export default SearchFilter;
